export function suppliersReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SUPPLIER":            
        case "UPDATE_SUPPLIER":
            let list = Object.assign({}, state);
            list[payload.supplier_id] = payload
        
            return list
        
        case "GET_SUPPLIERS":

            return payload
        case "DEBIT_SUPPLIER_ACCOUNT":
            let list4 = Object.assign({}, state)
            let supplier = list4[payload.supplier_id]

            console.log('====================================');
            console.log("DEBIT_SUPPLIER_ACCOUNT", payload, supplier, supplier.supplier_account );
            supplier.supplier_account -= payload.amount
            console.log("DEBIT_SUPPLIER_ACCOUNT", payload, supplier, supplier.supplier_account );
            console.log('====================================');

            list4[payload.supplier_id] = supplier
            
            return list4;
        
        default:
            return state;
    }
    
}